import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
import { apolloClient as client } from "../data-provider/graphqlDataProvider";

// let token: any = localStorage.getItem('credentials')
// const client = new ApolloClient({
//     uri: `${process.env.REACT_APP_DATAPROVIDER}`,
//     headers: { authorization: token },
//     cache: new InMemoryCache(),
// });

export async function getOrderList(params: any) {
    const GET_Orders = gql`
      query Orders($orderBy: [OrderOrderByInput!], $skip: Float, $take: Float, $where: OrderWhereInput){
        orders(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
          id
          customer
          usedDiscounts {
            id
            discount {
              id
              code        
            }
            status      
          }
          orderStatuses {
            id
            status        
          }
          basketItems{
            id
            productPrice  
            meta      
          }      
          createdAt
          updatedAt
          service
        }
        total: _ordersMeta(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
              count
            }
      }
    `;
    return client.query({
        query: GET_Orders,
        variables: {
            where: {
                service: { equals: process.env.REACT_APP_SERVICE },
                orderStatuses: params.filter.orderStatuses,
                updatedAt: {
                    ...params.filter.fromDate,
                    ...params.filter.toDate
                },
                customer: params.filter.lnCustomer
            },
            skip: params.pagination.perPage * (params.pagination.page - 1),
            take: params.pagination.perPage,
            orderBy: { updatedAt: "Desc" },

        }
    })
}
export async function getOrder(params: any) {
    const GET_Order = gql`
    query GetOrder($where: OrderWhereUniqueInput!){
      order(where: $where){
        createdAt
        createdBy
        customer
        id
        meta
        paymentId
        seller
        service
        basketItems{
          campaignPrice
          userPrice    
        }
        orderStatuses{
          status
        }
        usedDiscounts {
          id      
          status
          discount{
            id
            code
          }      
        }
      }
    }
    `;
    return client.query({
        query: GET_Order,
        variables: {
            where: {
                id: params.id
            }
        }
    })
}

export async function getCustomers(orders: Array<any>) {
    let customerIds: Array<any> = orders.map(o => o.customer.id)
    const GET_AuthUsers = gql`
    query GetCustomers($where: AuthUserWhere){
      authUsers(where: $where){
        id
        firstName
        lastName
        authMethods{
          mobile
        }
      }
    }
    `;
    return client.query({
        query: GET_AuthUsers,
        variables: {
            where: {
                authMethods: { some: { service: { equals: process.env.REACT_APP_AUTH_SERVICE } } },
                id: { in: customerIds }
            }
        }
    }).then((res) => {
        let result: Array<any> = orders.map((o: any) => {
            let customer = res.data.authUsers.find((c: any) => c.id === o.customer.id);
            return {
                ...o,
                customer
            }
        })
        return result;
    })
}